<template>
	<Modal
		v-if="visible"
		:key="formSubmitted"
		:prevent-scrolling="false"
		:allow-close="!formSubmitted"
		:hide-actions="true"
		:max-width="'sm:max-w-2xl'"
		@modal:close="handleClose"
	>
		<template
			v-if="formSubmitted"
			#header
		>
			<svg
				class="cursor-pointer"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				@click="handleBack"
			> 
				<g clip-path="url(#clip0_1670_67340)">
					<path
						d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
						fill="#96AAB7"
					/>
				</g>
				
				<defs>
					<clipPath id="clip0_1670_67340">
						<rect
							width="24"
							height="24"
							fill="white"
						/>
					</clipPath>
				</defs>
			</svg>
		</template>
		<template #body>
			<div class="px-4">
				<div class="mt-2 text-left font-[Inter] text-2xl font-semibold text-won-blue">{{ title }}</div>

				<div
					v-if="currentResumeSelected && currentResumeExperiencesCount<=1"
					class="mt-2 flex h-[61px] items-center rounded-md border border-[#FAA21B] bg-[#FDDAA459]"
				>
					<div class="flex h-full">
						<div class="flex w-[48px] shrink-0 items-center justify-center bg-[#FAA21B]">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M12.0001 14.3701C11.8012 14.3701 11.6104 14.2911 11.4697 14.1504C11.3291 14.0098 11.2501 13.819 11.2501 13.6201V8.0901C11.2501 7.89119 11.3291 7.70042 11.4697 7.55977C11.6104 7.41912 11.8012 7.3401 12.0001 7.3401C12.199 7.3401 12.3897 7.41912 12.5304 7.55977C12.6711 7.70042 12.7501 7.89119 12.7501 8.0901V13.6201C12.7514 13.719 12.7329 13.8171 12.6957 13.9087C12.6585 14.0003 12.6033 14.0835 12.5334 14.1534C12.4635 14.2233 12.3803 14.2785 12.2887 14.3158C12.1971 14.353 12.0989 14.3714 12.0001 14.3701ZM22.3901 20.1601C22.1619 20.5372 21.8384 20.8475 21.4522 21.06C21.066 21.2724 20.6307 21.3793 20.1901 21.3701H3.80007C3.36109 21.3776 2.92784 21.2698 2.54355 21.0574C2.15927 20.8451 1.8374 20.5357 1.61007 20.1601C1.35748 19.7186 1.22461 19.2188 1.22461 18.7101C1.22461 18.2014 1.35748 17.7016 1.61007 17.2601C2.07007 16.4301 4.26007 12.5901 6.20007 9.1901C7.86007 6.3801 9.32007 3.8301 9.57007 3.3801C9.74892 2.87877 10.0784 2.44502 10.5135 2.13832C10.9485 1.83163 11.4678 1.66699 12.0001 1.66699C12.5323 1.66699 13.0516 1.83163 13.4866 2.13832C13.9217 2.44502 14.2512 2.87877 14.4301 3.3801C14.6701 3.8301 16.1401 6.3801 17.7401 9.1901C19.6801 12.5901 21.8801 16.4301 22.3301 17.2601C22.5918 17.6964 22.7351 18.1935 22.7456 18.7021C22.7561 19.2108 22.6336 19.7134 22.3901 20.1601ZM21.0001 18.0001C20.5601 17.1801 18.3601 13.3401 16.4301 10.0001C14.8201 7.1801 13.3501 4.6101 13.1001 4.1501C12.6001 3.2301 12.3001 3.2301 11.9901 3.2301C11.6801 3.2301 11.3801 3.2301 10.8701 4.1501C10.6301 4.6101 9.16007 7.1501 7.55007 10.0001C5.62007 13.3201 3.43007 17.1601 3.00007 18.0001C2.86394 18.2073 2.78486 18.4468 2.77081 18.6944C2.75677 18.9419 2.80825 19.1888 2.92007 19.4101C3.01321 19.5635 3.14591 19.689 3.30427 19.7735C3.46262 19.8579 3.64078 19.8982 3.82007 19.8901H20.1901C20.371 19.9001 20.5513 19.8607 20.7115 19.7761C20.8718 19.6916 21.0061 19.5651 21.1001 19.4101C21.206 19.1863 21.2525 18.939 21.235 18.692C21.2175 18.445 21.1366 18.2067 21.0001 18.0001ZM12.0001 18.1301C12.1978 18.1301 12.3912 18.0715 12.5556 17.9616C12.7201 17.8517 12.8483 17.6955 12.9239 17.5128C12.9996 17.3301 13.0194 17.129 12.9809 16.935C12.9423 16.741 12.847 16.5628 12.7072 16.423C12.5673 16.2831 12.3891 16.1879 12.1952 16.1493C12.0012 16.1107 11.8001 16.1305 11.6174 16.2062C11.4347 16.2819 11.2785 16.4101 11.1686 16.5745C11.0587 16.739 11.0001 16.9323 11.0001 17.1301C11.0053 17.3918 11.113 17.6411 11.2999 17.8243C11.4869 18.0075 11.7383 18.1102 12.0001 18.1101V18.1301Z"
									fill="white"
								/>
							</svg>
						</div>
						<div class="mx-3 flex items-center">
							<p class="font-[Inter] text-sm font-normal text-[#3C3C3C]">
								<span v-if="currentResumeExperiencesCount==1">
									The selected resume only has 1 experience. We recommend selecting a resume with at least 2 experiences.
								</span>

								<span v-if="currentResumeExperiencesCount==0">
									The selected resume has no experiences. We recommend selecting a different resume or 
									<a
										class="cursor-pointer font-semibold text-[#3C3C3C]"
										@click="handleStartFromScratch"
									>
										start from scratch without a resume
									</a>.
								</span>
							</p>
						</div>
					</div>
				</div>

				<div
					v-else
					class="mt-2 h-[61px]"
				>
					<div class="text-left font-[Inter] text-sm font-normal text-won-blue">{{ subtitle }}</div>
				</div>
			</div>
           
			<div v-if="!formSubmitted">
				<div class="mt-[22px] h-[310px] overflow-y-auto px-4">
					<div
						v-if="formattedResumes?.length"
						:key="formSubmitted"
						role="radiogroup"
						aria-label="Select a resume"
						class="grid size-full grid-cols-3 gap-4"
					>
						<pdf-preview-card
							v-for="item of formattedResumes"
							:key="item.uuid"
							:preview="item"
							:hide-actions="true"
							:selectable="true"
							:selected="item.uuid==currentResumeSelected?.uuid"
							@selected="(item) => handleSelect(item)"
							@pdf-preview:refresh="refresh"
						/>
					</div>
    
					<div
						v-else
						class="flex justify-center"
					>
						<img
							:src="SelectResumeImage"
							class="h-[290px]"
						/>
					</div>
				</div>
    
				<won-button
					v-if="!resumes?.length"
					class="mx-auto mt-4 w-[190px]"
					@click="handleCreateNewResume"
				>
					+ Create New Resume
				</won-button>

				<won-button
					:disabled="!currentResumeSelected"
					:class="['mx-auto mt-6 w-full', {'opacity-25 hover:opacity-25': !currentResumeSelected }]"
					@click="handleNext"
				>Next</won-button>

				<div class="mt-2.5 flex items-center justify-start">
					<p
						class=" font-[Roboto] text-sm font-normal text-black"
					>
						You can also &nbsp;
					</p>

					<upload-resume
						:collapsed="true"
						:is-flat="true"
						wrapper-class-list="inline-block"
						form-class-list="mt-0"
						@done="handleUpload"
						@view-uploaded-resume="handleClose"
					>
						<span
							class="cursor-pointer px-0.5 font-[Roboto] text-sm font-semibold text-won-green underline"
						>
							upload a resume
						</span>
					</upload-resume>

					<p
						class="font-[Roboto] text-sm font-normal text-black"
					>
						or&nbsp;
						<span
							class="cursor-pointer font-semibold text-won-green underline"
							@click="handleStartFromScratch"
						>
							start from scratch without a resume
						</span>.
					</p>
				</div>
			</div>

			<div
				v-else
				class="h-full overflow-auto px-1"
			>
				<TextInput
					v-model="targetJob"
					placeholder="e.g. Project Manager, Software Engineer, Sales Intern"
				>
					Target Role
				</TextInput>
        
				<TextInput
					v-if="startedFromScratch"
					v-model="previousRoles"
					class="mt-5"
					placeholder="e.g. Software developer"
				>
					Previous Roles
				</TextInput>
                
				<TextInput
					v-model="targetCompany"
					class="mt-5"
					placeholder="e.g. Google, Microsoft, Tesla"
				>
					Target Company
				</TextInput>
                
				<Textarea
					v-model="jobDescription"
					class="mt-5"
					placeholder="For Example:&#10;Partner with product management and engineering to define the strategy and roadmap&#10;Surface & synthesize qualitative & quantitative insights that shape product direction"
				>
                    Job Responsibilities
                </Textarea>

				<Skills 
					v-if="startedFromScratch"
					v-model="skills"
					placeholder="Add your skills"
				>
					Skills
					<template #subtitle>
						<p class="mt-1 font-[Inter] text-xs font-normal text-[#5E5E5E] italic">
							Click enter to add as many skills as you want.
						</p>
					</template>
				</Skills>

				<button
					:disabled="isDisabled"
					:class="[
						{
							'won-green-button-color': !isDisabled,
							'won-green-button-color-disabled': isDisabled,
						},
						buttonStyle,
						'mt-8',
					]"
					@click="handleSubmit()"
				>
					<div class="flex items-center">
						<LoadingIcon
							v-if="loading"
							class="animate-spin"
						/>
						<div class="ml-2">
							{{ loading ? "Generating..." : "Generate" }}
						</div>
					</div>
				</button>
			</div>
		</template>
	</Modal>
</template>

<script setup>
import { onMounted, onUnmounted, toRefs, ref, computed, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import Modal from '../components/modal';

import TextInput from '../forms/elements/text';
import Skills from '../forms/elements/skills';

import LoadingIcon from '../icons/loading';

import WonButton from '../components/won-button';

import { buttonStyle } from '../utils/styles';


import { useResumesStore } from '../store/resumes.store';

import { useOnboardingStore } from '../store/onboarding.store';
import { generateCoverLetter } from '../api/cover-letters';

import PdfPreviewCard from '../components/pdf/pdf-preview-card';
import UploadResume from '../components/upload-resume';

import { useFeatureUsageStore } from '../store/feature-usage.store';
import { useOnboardingChecklist } from '../store/onboarding-checklist.store';

import { useNotifications } from '../store/notifications.store';
import Textarea from '../forms/elements/textarea.vue';

const SelectResumeImage = '/img/select-resume.png';

const props = defineProps({
	visible: {
		type: Boolean,
		default: false,
	}
});

const onboardingStore = useOnboardingStore();
const { onboardingStep, isOnboarding } = storeToRefs(onboardingStore);

const notificationStore = useNotifications();

watch(() => isOnboarding.value, (newval) => {
	if (!newval) {handleReset();}
});

watch(() => onboardingStep.value, (newval) => {
	if (newval === 'onboarding-select-resume') {handleBack();}
	if (newval === 'onboarding-select-resume-step2') {handleStartFromScratch();}
});

const title = ref('Select a Resume from WonsultingAI');
const subtitle = ref('It seems you haven’t created a resume with ResumAI yet, we highly recommend you to create one before, please click on “Create a resume” to create it with our resume builder.');

const { visible } = toRefs(props);
const emit = defineEmits(['delete-modal:close', 'networking:limit-error']);

const currentResumeSelected = ref(null);
const formSubmitted = ref(false);
const startedFromScratch = ref(false);
const loading = ref(false);
const uploaded = ref(false);

const targetJob = ref('');
const targetCompany = ref('');
const jobDescription = ref('');
const previousRoles = ref('');
const skills = ref([]);

const router = useRouter();
const route = useRoute();

const errors = ref([]);

const currentResumeExperiencesCount = computed(() => {
	if (! currentResumeSelected.value) {return;}

	return currentResumeSelected.value?.experiences_count || 0;
});

const isDisabled = computed(() => {
	if (startedFromScratch.value) {
		return !targetJob.value || !targetCompany.value || !previousRoles.value || !skills.value.length;
	} 
	return !targetJob.value || !targetCompany.value;
    
});

const handleCreateNewResume = () => {
	const routeData = router.resolve({ name: 'resumes.edit' });
	window.open(routeData.href, '_blank');
};

const featureUsageStore = useFeatureUsageStore();
const onboardingChecklistStore = useOnboardingChecklist();


const resumesStore = useResumesStore();
resumesStore.fetchResumes();
const { resumes, formattedResumes } = storeToRefs(resumesStore);

const refresh = () => {
	resumesStore.fetchResumes();
};

const handleReset = () => {
	targetJob.value = '';
	targetCompany.value = '';
	previousRoles.value = '';
	skills.value = [];

	currentResumeSelected.value = null;
	formSubmitted.value = false;
	startedFromScratch.value = false;
	loading.value = false;
	uploaded.value = false;
};

const handleUpload = (resume) => {
	uploaded.value = true;

	refresh();
	handleSelect(resume);
    
	setTimeout(() => {
		handleNext();
	}, 1500);
};

const handleSelect = (item) => {
	currentResumeSelected.value = item;
};

const handleWindowFocus = () => {
	if (visible.value) {
		refresh();
	}
};

onMounted(() => {
	window.addEventListener('focus', handleWindowFocus);

	document.onkeydown = function(e) {
		if (e.key === 'Escape' && visible.value) {
			handleClose();
		}
	};
});

onUnmounted(() => {
	window.removeEventListener('focus', handleWindowFocus);
});

const handleClose = (message = null) => {
	emit('delete-modal:close', message);
};

const handleStartFromScratch = () => {
	startedFromScratch.value = true;
	formSubmitted.value = true;
	currentResumeSelected.value = null;

	title.value = 'Add your information';
	subtitle.value = 'Please check all the relevant information you want us to consider for creating your cover letter.';
};

const handleNext = () => {
	if (! currentResumeSelected.value) {return;}
	formSubmitted.value = true;
	startedFromScratch.value = false;

	title.value = 'Review your information';
	subtitle.value = 'Please check all the relevant information you want us to consider for creating your cover letter.';
};

const handleBack = () => {
	formSubmitted.value = false;
    
	targetJob.value = '';
	targetCompany.value = '';
	previousRoles.value = '';
	skills.value = [];

	title.value = 'Select a Resume from WonsultingAI';
	subtitle.value = 'Click to select a resume from the list, then click on next to see all of your imported information. You can also preview it before selecting.';
};

const handleSubmit = () => {
	loading.value = true;
	generateCoverLetter(route.params.id, {
		target_job: targetJob.value,
		target_company: targetCompany.value,
		skills: skills.value,
		previous_roles: previousRoles.value,
		job_description: jobDescription.value,

		resume_id: currentResumeSelected.value?.uuid
	})
		.catch((err) => {
			const data = err?.response?.data;
        
			if (err?.response?.status === 429) {
				emit('networking:limit-error');
				handleClose();
				return;
			}

			if (data?.errors == null || typeof data?.errors !== 'object') {
				errors.value = ['Failed to generate cover letter, please try again!'];
				return;
			}
        
			errors.value = Object.keys(data.errors).map((k) => data.errors[k][0]);
		})
		.then((res) => {
			handleReset();
			const completion = res?.data?.completion;

			if (! completion?.replace(/\s/g, '').length ) {
				notificationStore.notify('Internal error! Please try one more time.', 'error');
			} else {
				handleClose(res?.data?.completion);
				onboardingChecklistStore.markItemAsCompleted(2, 'generateFirstCoverLetter');
				featureUsageStore.refresh();
			}
		}).finally(() => {
			setTimeout(() => {
				loading.value = false;
			}, 500);
		});
};
</script>
